<template>
  <v-row class="ChipsColumns chips-columns">
    <v-col
      v-for="item in items"
      :key="item.title"
      cols="12"
      md="6"
      class="d-flex align-center"
    >
      <v-chip
        :outlined="outlined"
        :color="outlined ? null : 'grey lighten-4'"
        pill
        :style="{ flexBasis: `${chipWidth}px` }"
        class="chips-columns__item-chip elevation-2"
      >
        <v-avatar left tile color="#baa7a7">
          <v-icon size="22" color="white">{{ item.icon }}</v-icon>
        </v-avatar>
        <div class="flex-grow-1 text-center text-uppercase">{{ item.title }}</div>
      </v-chip>
      <v-sheet
        rounded
        elevation="2"
        color="white"
        class="flex-grow-1 pa-3 ml-3"
      >
        <span class="font-weight-bold">{{ item.text }}</span>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ChipsColumns',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    chipWidth: {
      type: [String, Number],
      default: 125,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.chips-columns {
  &__item-chip {
    width: 100%;
  }

  &__item-chip::v-deep .v-chip__content {
    flex-grow: 1;
  }
}
</style>
